<template>

<div>

  <LDBsTable
    url="active-status"
    defaultSort="location"
    defaultOrder="asc"
    :query="query"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-4">
      <label for="status">{{ $t('status') }}</label>
      <Combobox
        class="bg-white"
        name='status'
        :placeholder="$t('select_a_item')"
        label="name"
        :options="status.rows"
        v-model="query.status"
        :reduce="status => status.id"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="location">{{ $t('location') }}</label>
      <Combobox
        class="bg-white"
        name='location'
        :placeholder="$t('select_a_item')"
        :options="locations"
        v-model="query.location"
      />
    </div>

    <div class="form-group col-lg-4">
      <label for="active_type">{{ $t('active_type') }}</label>
      <Combobox
        class="bg-white"
        name='active_type'
        :placeholder="$t('select_a_item')"
        label="name"
        :options="activestypes"
        v-model="query.activeType"
        :reduce="activeType => activeType.id"
      />
    </div>
  </LDBsTable>

</div>

</template>

<script>
import { mapState } from 'vuex'
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import location from '@/config/locations'

export default {
  name: 'ActiveStatusList',
  components: {
    LDBsTable,
    Combobox
  },
  data () {
    return {
      columns: [
        {
          title: this.$t('status'),
          field: 'status',
          formatter: value => {
            return value
              ? value.name
              : '-'
          },
          sortable: true
        },
        {
          title: this.$t('location'),
          field: 'location',
          sortable: true
        },
        {
          title: this.$t('active_type'),
          field: 'activeType',
          formatter: function (value) {
            return value
              ? value.name
              : '-'
          }
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/active-status/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'status_de_ativos' }
      },
      query: {
        id: undefined,
        status: undefined,
        location: '',
        activeType: undefined,
      },
      locations: location
    }
  },

  computed: {
    ...mapState({
      activestypes: state => state.activestype.all,
      status: state => state.status.all
    })
  },

  methods: {
    clear() {
      this.query.status = undefined
      this.query.location = ''
      this.query.activeType = undefined
    }
  },

  async mounted() {
    const { dispatch } = this.$store
    await dispatch('activestype/fetchAll')
    await dispatch('status/fetchAll')
  },

  destroyed() {
    const { dispatch } = this.$store

    dispatch('activestype/cleanState')
    dispatch('activestatus/cleanState')
    dispatch('status/cleanState')
  }
}
</script>